import axios from 'axios';

export const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
});

export function assetUrl(path) {
  if (!path) return null;
  return `${API_ORIGIN}${path}`;
}

export async function fetchMandals() {
  const { data } = await api.get('/mandals');
  return data.mandals;
}

export async function fetchMandalBySlug(slug) {
  const { data } = await api.get(`/mandals/${slug}`);
  return data.mandal;
}

export async function registerMandal(payload) {
  const { data } = await api.post('/mandals/register', payload);
  return data;
}

export async function fetchEvents() {
  const { data } = await api.get('/events');
  return data.events;
}

export async function fetchEventById(id) {
  const { data } = await api.get(`/events/${id}`);
  return data.event;
}

export async function submitContactInquiry(payload) {
  const { data } = await api.post('/contact', payload);
  return data;
}

export async function createDonationOrder(payload) {
  const { data } = await api.post('/donations/order', payload);
  return data;
}

export async function verifyDonationPayment(payload) {
  const { data } = await api.post('/donations/verify', payload);
  return data;
}
